module.exports = __webpack_public_path__ + "static/media/AmeliaCarlie_DesignPortfolio.66bf1082.pdf";